import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext, { Language } from 'src/AppContext';
import { Language as APILanguage, UserSettingsPayload } from 'src/graphql/generated/types';

// note that the return value is strange... would have expected notification object...
const mutation = `mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      language
    }
  }`;

const mapToApiLanguage = (language: Language) => {
    //return language === 'zh-Hant' ? 'ZHHANT' : language.toUpperCase();
    return language.toUpperCase();
};

export const mapFromApiLanguage = (language: APILanguage): Language => {
    //return language === 'ZHHANT' ? 'zh-Hant' : language.toLowerCase() as Language;
    return language.toLowerCase() as Language;
};

export const useUpdateUserSettings = () => { // TODO: the name is not valid anymore... we just set the language and nothing else ...

    const context = useContext(AppContext);

    return useMutation({
        mutationFn: async (language: Language) => {

            const languageId = mapToApiLanguage(language);

            const response = await (context.api.graphql({
                query: mutation,
                variables: {
                    input: {
                        language: languageId,
                    },
                },
            }) as Promise<{
                data: {
                    updateUserSettings: UserSettingsPayload;
                };
            }>);

            return !!response.data.updateUserSettings.language;
        },
    });
};
